import * as i0 from "@angular/core";
export let CurrencyPipe = /*#__PURE__*/(() => {
  class CurrencyPipe {
    transform(value, currency = 'euro') {
      const currencySign = ' €';
      if (typeof value !== 'number' || isNaN(value)) {
        return '0,00 ' + currencySign;
      }
      return value.toFixed(2).replace('.', ',') + currencySign;
    }
    static {
      this.ɵfac = function CurrencyPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CurrencyPipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "currency",
        type: CurrencyPipe,
        pure: true
      });
    }
  }
  return CurrencyPipe;
})();